import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "side-menu-field-descr text-truncate" }
const _hoisted_2 = { class: "field-input" }
const _hoisted_3 = {
  key: 0,
  class: "side-menu-field-descr text-truncate mb-2"
}
const _hoisted_4 = { class: "side-menu-field-descr text-truncate mb-2" }

import {computed} from 'vue';
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import Delay from "~/ts/library/Delay";
import {__} from "~/ts/library/Translate";
import SideMenuCard from "~/operatorApplication/vue/dialogs/dialog/sidemenu/SideMenuCard.vue";
import SideMenuCardSection from "~/operatorApplication/vue/dialogs/dialog/sidemenu/SideMenuCardSection.vue";

import {
    STANDART_FIELD_NAMES
} from "~/operatorApplication/ts/data/StandartClientFields";
import ClientTags from "~/operatorApplication/vue/dialogs/dialog/sidemenu/info/fields/ClientTags.vue";
import Tags from "~/cabinet/vue/interface/data/Tags.vue";
import AttachedOperatorsSelect
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/info/attachedOperatorsSelect/AttachedOperatorsSelect.vue";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import ClientFieldsList from "~/operatorApplication/vue/dialogs/dialog/sidemenu/info/fields/ClientFieldsList.vue";
import DialogDataCardSections from "~/operatorApplication/vue/dialogs/dialog/sidemenu/info/DialogDataCardSections.vue";
import DialogOperatorsList from "~/operatorApplication/vue/dialogs/dialog/sidemenu/dialogsTab/DialogOperatorsList.vue";
import DialogAssigneeSelect from "~/operatorApplication/vue/dialogs/dialog/sidemenu/DialogAssigneeSelect.vue";
import {DialogAssigneeSelectModelInterface} from "~/operatorApplication/vue/dialogs/dialog/sidemenu/Interface";
import MyLoader from "~/cabinet/vue/interface/data/MyLoader.vue";
import getLastClientDialogStatus from "~/operatorApplication/ts/data/getLastClientDialogStatus";
import SideMenuInfo from "~/operatorApplication/vue/dialogs/dialog/sidemenu/info/SideMenuInfo.vue";
import {INTERNATIONAL_LCAB_HOST, isInternationalHostEnabled} from "~/core-ui/ts/Constants";
import ElNotify from "~/core-ui/vue/ui/ElNotify";



import {ref} from 'vue';

let clientStandartFieldsCollapsed = ref(false);
let clientCustomFieldsCollapsed = ref(false);
let lastDialogCollapsed = ref(false);

const __default__ = {
    name: "SideMenuClientFields"
};

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    userdata: {},
    site: {},
    readonly: { type: Boolean },
    hideNotFilledClientFieldsEnabled: { type: Boolean, default: true },
    onMessageTagClick: {}
  },
  setup(__props: any) {

let props = __props;

function copyLinkToClipboard() {
    let url = props.userdata.linkToApplication;
    if (isInternationalHostEnabled()) {
        let a = document.createElement("a");
        a.href = url;
        a.host = INTERNATIONAL_LCAB_HOST;
        url = a.href;
    }
    navigator.clipboard.writeText(url).then(() => {
        ElNotify.success({
            title: __('Скопировано в буфер обмена'),
            duration: 2000,
            message: null
        });
    }, () => {
        ElNotify.error({
            title: __('Не удалось скопировать в буфер обмена'),
            duration: 2000,
            message: null
        });
    });
}

async function sendUpdateClientInfoRequest(p: OperatorApplicationApi.OperatorBuddyListUpdateClientInfoOpenApiModel) {
    return await (new OperatorApiRequest({
        url: "/buddyList/updateClientInfo",
        p,
        silent: true
    })).send()
}

function isForCustom(field: OperatorApplicationApi.AbstractFormElementOpenApiModel) {
    return !STANDART_FIELD_NAMES.includes(field.name);
}

let localTags = ref<string[]>();

async function onClientTagsChange(tags: string[]) {
    try {
        props.userdata.tags = localTags.value = tags;
        await Delay.make(3000, `clientTagsChange`, true);
        let p: OperatorApplicationApi.OperatorBuddyListUpdateClientInfoOpenApiModel = {
            username: props.userdata.username,
            tags: tags
        };
        let result = await sendUpdateClientInfoRequest(p);
        result.showMessageOnError();
        if (JSON.stringify(localTags.value) === JSON.stringify(tags)) {
            localTags.value = undefined;
        }
    } catch (e) {
        if (JSON.stringify(localTags.value) === JSON.stringify(tags)) {
            localTags.value = undefined;
        }
    }
}

let localDialogAssigned = ref<DialogAssigneeSelectModelInterface>();
let dialogAssignedUpdateInProcess = ref(false);

let lastDialogStatus = computed(() => getLastClientDialogStatus(props.userdata));

async function onDialogAssignedChange(assigned: DialogAssigneeSelectModelInterface) {
    try {
        localDialogAssigned.value = assigned;
        await Delay.make(3000, `dialogAssignedChange`, true);

        let p: OperatorApplicationApi.OperatorMessageSetDialogStatusOpenApiModel = {
            username: props.userdata.username,
            dialogId: props.userdata.lastDialog.id,
            assigned: localDialogAssigned.value
        };

        dialogAssignedUpdateInProcess.value = true

        let result = await (new OperatorApiRequest({
            url: "/message/setDialogStatus",
            p,
            silent: true
        })).send()

        result.showMessageOnError();
        localDialogAssigned.value = undefined;
    } catch (e) {
        //localDialogAssigned.value = undefined
    }
    dialogAssignedUpdateInProcess.value = false;
}

let flags = computed(() => {
    return props.site.flags;
});

async function setFlag(flagId: string) {
    if (canEdit.value) {
        props.userdata.flagId = flagId;
        let p: OperatorApplicationApi.OperatorBuddyListUpdateClientInfoOpenApiModel = {
            username: props.userdata.username,
            flagId: flagId ? flagId : ""
        };
        let result = await sendUpdateClientInfoRequest(p);
        result.showMessageOnError();
    }
}

let canEdit = computed(() => {
    return !props.readonly;
});

let messageTags = computed(() => {
    return props.userdata.taggedMessages.map(item => item.tag);
});

function messageTagClickListener(tag: string) {
    if (props.onMessageTagClick) {
        let taggedMessage = props.userdata.taggedMessages.find(item => item.tag == tag);
        if (taggedMessage) {
            props.onMessageTagClick(taggedMessage);
        }
    }
}

return (_ctx: any,_cache: any) => {
  const _directive_my_tooltip = _resolveDirective("my-tooltip")!
  const _directive_on_native = _resolveDirective("on-native")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(SideMenuCard, {
      collapsed: _unref(clientStandartFieldsCollapsed),
      "onUpdate:collapsed": _cache[0] || (_cache[0] = ($event: any) => (_isRef(clientStandartFieldsCollapsed) ? (clientStandartFieldsCollapsed).value = $event : clientStandartFieldsCollapsed = $event))
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(__)("Клиент")), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(SideMenuInfo, { icon: "hashtag" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.userdata.id) + " ", 1),
            (__props.userdata.linkToApplication)
              ? _withDirectives((_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "float-right",
                  onClick: _withModifiers(copyLinkToClipboard, ["prevent","stop"])
                }, [
                  _createVNode(FontAwesomeIcon, { icon: "external-link" })
                ])), [
                  [_directive_my_tooltip, _unref(__)('Скопировать ссылку')]
                ])
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(ClientFieldsList, {
          userdata: __props.userdata,
          "field-values": __props.userdata.fields,
          fields: __props.site.userFields.filter(field => !isForCustom(field)),
          "show-icons": true,
          "show-titles": false,
          "is-custom": false,
          links: __props.userdata.fieldLinks,
          "standart-field-names": _unref(STANDART_FIELD_NAMES),
          "is-client": "",
          "send-update-request": (fields) => sendUpdateClientInfoRequest({username: _unref(props).userdata.username, fields})
        }, null, 8, ["userdata", "field-values", "fields", "links", "standart-field-names", "send-update-request"]),
        _createVNode(ClientTags, {
          descr: _unref(__)('Тэги клиента'),
          "can-edit": _unref(canEdit),
          "model-value": _unref(localTags) ?? __props.userdata.tags,
          tags: __props.site.clientTags,
          "onUpdate:modelValue": onClientTagsChange
        }, null, 8, ["descr", "can-edit", "model-value", "tags"]),
        (_unref(messageTags).length)
          ? (_openBlock(), _createBlock(SideMenuCardSection, {
              key: 0,
              class: "operator-side-menu-field",
              compact: ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(__)("Сообщения с тэгами")), 1),
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(Tags, {
                    tags: _unref(messageTags),
                    "possible-tags": __props.site.messageTags,
                    "with-border": "",
                    clickable: !!_unref(props).onMessageTagClick,
                    onClick: messageTagClickListener
                  }, null, 8, ["tags", "possible-tags", "clickable"])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(AttachedOperatorsSelect, {
          userdata: __props.userdata,
          site: __props.site
        }, null, 8, ["userdata", "site"]),
        _createVNode(SideMenuCardSection, { class: "operator-side-menu-field text-center" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(flags), (flag) => {
              return _withDirectives((_openBlock(), _createBlock(FontAwesomeIcon, {
                key: flag.id,
                class: _normalizeClass({
                        'flag': true,
                        selected: flag.id === __props.userdata.flagId
                    }),
                icon: "flag",
                light: flag.id != __props.userdata.flagId,
                bold: flag.id === __props.userdata.flagId,
                style: _normalizeStyle({color: flag.color})
              }, null, 8, ["class", "light", "bold", "style"])), [
                [_directive_on_native, () => setFlag(flag.id), "click"]
              ])
            }), 128)),
            (__props.userdata.flagId)
              ? _withDirectives((_openBlock(), _createBlock(FontAwesomeIcon, {
                  key: 0,
                  class: _normalizeClass({
                        flag: true,
                        'text-default': true
                    }),
                  light: "",
                  icon: "times"
                }, null, 512)), [
                  [_directive_on_native, () => setFlag(null), "click"]
                ])
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["collapsed"]),
    (__props.userdata.lastDialog && (__props.site.dialogTags.length || __props.site.dialogFields.length || __props.site.questionCategoriesTree.length))
      ? (_openBlock(), _createBlock(SideMenuCard, {
          key: 0,
          collapsed: _unref(lastDialogCollapsed),
          "onUpdate:collapsed": _cache[1] || (_cache[1] = ($event: any) => (_isRef(lastDialogCollapsed) ? (lastDialogCollapsed).value = $event : lastDialogCollapsed = $event))
        }, {
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(__)('Последний диалог')), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(DialogDataCardSections, {
              dialog: __props.userdata.lastDialog,
              userdata: __props.userdata,
              site: __props.site
            }, null, 8, ["dialog", "userdata", "site"]),
            (_unref(lastDialogStatus)?.isNeedToSetAssignedOnStatusChange)
              ? (_openBlock(), _createBlock(SideMenuCardSection, {
                  key: 0,
                  class: "operator-side-menu-field"
                }, {
                  default: _withCtx(() => [
                    (_unref(localDialogAssigned) || __props.userdata.lastDialog.assigned.groupIds.length || __props.userdata.lastDialog.assigned.operatorLogins.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          (_unref(dialogAssignedUpdateInProcess))
                            ? (_openBlock(), _createBlock(MyLoader, { key: 0 }))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(_unref(__)("Ответственные за диалог")), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(DialogAssigneeSelect, {
                      userdata: __props.userdata,
                      "model-value": _unref(localDialogAssigned) ?? __props.userdata.lastDialog.assigned,
                      filterable: false,
                      disabled: _unref(dialogAssignedUpdateInProcess),
                      placeholder: _unref(__)('Ответственные за диалог не назначены'),
                      "onUpdate:modelValue": onDialogAssignedChange
                    }, null, 8, ["userdata", "model-value", "disabled", "placeholder"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (__props.userdata.lastDialog.operatorLogins?.length)
              ? (_openBlock(), _createBlock(SideMenuCardSection, { key: 1 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(__)("Участвовавшие в диалоге операторы")), 1),
                    _createVNode(DialogOperatorsList, {
                      class: "flex-fill",
                      max: 5,
                      "negative-margin": 2,
                      dialog: __props.userdata.lastDialog
                    }, null, 8, ["dialog"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["collapsed"]))
      : _createCommentVNode("", true),
    _createVNode(SideMenuCard, {
      collapsed: _unref(clientCustomFieldsCollapsed),
      "onUpdate:collapsed": _cache[2] || (_cache[2] = ($event: any) => (_isRef(clientCustomFieldsCollapsed) ? (clientCustomFieldsCollapsed).value = $event : clientCustomFieldsCollapsed = $event))
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(__)("Дополнительные поля")), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(ClientFieldsList, {
          userdata: __props.userdata,
          "field-values": __props.userdata.fields,
          fields: __props.site.userFields.filter(field => isForCustom(field)),
          "show-icons": false,
          "show-titles": true,
          "is-custom": true,
          "standart-field-names": _unref(STANDART_FIELD_NAMES),
          "is-client": "",
          links: __props.userdata.fieldLinks,
          "send-update-request": (fields) => sendUpdateClientInfoRequest({username: _unref(props).userdata.username, fields})
        }, null, 8, ["userdata", "field-values", "fields", "standart-field-names", "links", "send-update-request"])
      ]),
      _: 1
    }, 8, ["collapsed"])
  ]))
}
}

})